<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import alertList from "./alert-list";
export default {
  components: { Layout, PageHeader, alertList },
  data() {
    return {};
  },
};
</script>

<template>
  <Layout>
    <alert-list />
  </Layout>
</template>